import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: (label?: string) => ({
    marginRight: {
      default: '-33px',
      '@media (max-width: 767px)': '0',
    },
    display: 'flex',
    position: 'relative',
    ':hover': {
      ':not(#__unused__) > div > div > button > span': {
        display: 'flex',
      },
      ':not(#__unused__) > div > div > button[aria-label="Переместить поле"]': {
        display: 'flex',
      },
    },
    marginTop: label ? '24px' : '16px',
    ':first-of-type': {
      marginTop: '8px',
    },
  }),
  content: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: {
      default: '33px',
      '@media (max-width: 767px)': '0',
    },
    flexGrow: 1,
  },
  label: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['greyWhite'],
    marginBottom: anatomy['space-4'],
  },
  editableLabel: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryInverseText,
    marginBottom: anatomy['space-4'],
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    width: '100%',
    paddingBottom: '2px',
  },
  editableLabelContent: {
    cursor: 'text',
    display: 'block',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryInverseText,
    marginBottom: anatomy['space-4'],
    wordBreak: 'break-word',
    width: '100%',
    minHeight: '20px',
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${palette['lighted-10']}`,
    ':hover': {
      ':not(#__unused__) > button:first-of-type': {
        display: 'flex',
      },
    },
  },
  input: {
    backgroundColor: 'transparent',
    padding: '8px 16px',
    paddingRight: '40px',
    boxSizing: 'border-box',
    height: '36px',
    outline: 'none',
    borderRadius: anatomy.borderRadiusXs,
    border: `none !important`,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['greyWhite'],
    width: '100%',
    '::placeholder': {
      color: palette['grey-500'],
    },
    ':-webkit-autofill': {
      boxShadow: `0 0 0 1000px ${colors.primaryInverseBackground} inset`,
      color: colors.primaryInverseText,
      '-webkit-text-fill-color': colors.primaryInverseText,
    },
    ':-webkit-autofill:focus': {
      color: colors.primaryInverseText,
      '-webkit-text-fill-color': colors.primaryInverseText,
    },
  },
  inputError: {
    border: `1px solid ${colors.errorBorder}`,
  },
  textError: {
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: '12px',
    color: colors.errorText,
    marginTop: anatomy['space-4'],
  },
  gripIcon: {
    display: 'none',
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '20px',
    width: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'grab',
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
  },
  removeButton: {
    display: 'none',
    padding: anatomy['size-4'],
    background: colors.accentBackground,
    borderRadius: anatomy.borderRadiusXs,
    position: 'absolute',
    right: '-33px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
});
